export const LANGUAGES = [
    { label: "English", code: "en" },
    { label: "Deutsch", code: "de" },
    { label: "Русский", code: "ru" },
    { label: "All", code: "all" },
];

export const AUDIO_FILES = [
    /* NEGATIVE ANTWORTEN */
    "https://static.roomab.art/mp3/eto-ne-seresno-operacia-y6fe822ea471cced314639db4218229f4.mp3",
    "https://static.roomab.art/mp3/ne-moozhhet-biiit-ne-smeeshshsite-mmemenniiiiaaff8559b0668329cfe29804d0e9ea0c0e.mp3",
    "https://static.roomab.art/mp3/hhhvvkskakkatititti_nnaaaddoooeeelo_vvbnndvkaitiinyt_nnaaddoiieelo.mp3",
    "https://static.roomab.art/mp3/huuuuzzghhe_kooggllddsgg_cchhhehesshshuuttiuussia.mp3",
    /* VORSCHLAGEN */
    "https://static.roomab.art/mp3/films_plus_cuts/zdravstvuyte_ya_vasha_tetya/vhhohoororossshsho_bby_vypiiitt.mp3",
    "https://static.roomab.art/mp3/kvn/KVN.2011.(1.1_8).mgimo.hren_s_nimi.mp3"
]
